/**
 * Next.js client-side instrumentation entry point.
 *
 * Runs in the browser (client runtime) before your application code,
 * which makes it the right place to install the local tracing fetch shim.
 *
 * IMPORTANT:
 * - This is local-only to keep  OTEL exporters out of the production bundles.
 */

import { isLocalTracingEnabled } from '@bts-web/utils-next-infrastructure';

export async function onRouterTransitionStart() {
  if (!isLocalTracingEnabled()) {
    return;
  }

  const { resetNavigationContextLocal } = await import(
    '@bts-web/utils-next-infrastructure/monitoring/local'
  );

  resetNavigationContextLocal();
}

(async () => {
  if (isLocalTracingEnabled()) {
    try {
      const { initClientTracingLocal } = await import(
        '@bts-web/utils-next-infrastructure/monitoring/local'
      );

      initClientTracingLocal();
    } catch (error) {
      console.error('[Client Tracing] Failed to initialize fetch shim:', error);
    }
  }
})();
